module.exports = __webpack_public_path__ + "img/gold18.62c42ece.svg";